module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-03-medium-ada182193f3ec44a62b97d73841e1538.jpg";